<template>
  <!-- 通知 -->
  <div class="firm-body">
    <!-- 标题 通知 -->
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">通知</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <!-- 筛选区 -->
      <el-form class="screen" :inline="true" @submit.native.prevent>
      
      <div class="screen-end">
      <el-form-item label="时间：">
      <el-date-picker
      v-model="value1"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="value1 = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn button" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn button" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
      <!-- 切换 -->
      <div class="Toggle">
        <div
          v-for="(item, index) in selectArr"
          :key="index"
          class="toggle-item"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 批量删除 批量恢复 -->
      <div class="batch-btn">
        <div class="Tips" v-if="select == '5'">
          回收站信息保留30天，30天后自动清除
        </div>
        <el-button
          type="primary"
          class="batch-action firm-clickable"
          v-if="select == '5'"
          @click="handelBatchRecovery"
        >
          批量恢复{{
            multipleSelection.length != 0 ? multipleSelection.length : ""
          }}
        </el-button>
        <el-button type="danger" class="batch-action delete-p" @click="handelDele">
          批量删除{{
            multipleSelection.length != 0 ? multipleSelection.length : ""
          }}
        </el-button>
      </div>
      <!-- 内容 -->
      <div class="collected">
        <tableMess
          :tableData="tableData"
          :select="select"
          :RefreshModule="RefreshModule"
          @Refresh="Refresh"
          @handleSelectionChange="handleSelectionChange"
        ></tableMess>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  sysCompanyMsgList, //企业消息列表
  trashCompanyMsg, //消息丢弃到回收站
  restoreCompanyMsg, //消息从回收站恢复
  delCompanyMsg, // 删除
  companyNoReadCount, //未读消息数量
} from "../../../../assets/api/firm/firmCenter";
// 引入分页组件
import paging from "../../../../components/paging.vue";
// 引入表格组件
import tableMess from "./components/tableMess.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //总数
      }, // 分页数据
      value1: null, // 时间搜索
      select: "1", // 筛选
      selectArr: [
        { name: "全部消息", id: 1, argumentName: "delFlag", argument: 0 },
        { name: "系统消息", id: 2, argumentName: "msgType", argument: 0 },
        // { name: "中标消息", id: 6, argumentName: "msgType", argument: 1 },
        { name: "已读", id: 3, argumentName: "msgStatus", argument: 1 },
        { name: "未读", id: 4, argumentName: "msgStatus", argument: 0 },
        { name: "回收站", id: 5, argumentName: "delFlag", argument: 2 },
      ], //筛选数组
      tableData: [], //表格数据
      dialogDele: false, // 删除弹窗
      num: "", // 传参给组件区分样式 传给组件  56删除 7恢复
      multipleSelection: [], // 列表多选数据
      RefreshModule: 0, // 批量操作后改变该数传给组件，组件监听到此数据改变清空选中数据
    };
  },
  components: { paging, tableMess },
  created() {
    this.sysMsgList();
    // 未读消息数量(只有未读暂无用处)
    // this.companyNoReadCount()
  },
  methods: {
    // 未读消息数量
    companyNoReadCount() {
      companyNoReadCount().then((res) => {});
    },
    // 表格多选数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 刷新列表数据
    RefreshSysMsgList() {
      if (this.select == 1) {
        this.sysMsgList("", "", "");
      } else if (this.select == 2) {
        this.sysMsgList(0, "", "");
      } else if (this.select == 3) {
        this.sysMsgList("", 1, "");
      } else if (this.select == 4) {
        this.sysMsgList("", 0, "");
      } else if (this.select == 5) {
        this.sysMsgList("", "", 2);
      }
    },
    // 从新加载数据
    Refresh() {
      setTimeout(() => {
        this.RefreshSysMsgList();
      }, 1000);
    },
    // 消息类型的切换
    handelSelect(item) {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      if (item.id == 1) {
        this.sysMsgList("", "", "");
      } else if (item.id == 2) {
        this.sysMsgList(0, "", "");
      } else if (item.id == 3) {
        this.sysMsgList("", 1, "");
      } else if (item.id == 4) {
        this.sysMsgList("", 0, "");
      } else if (item.id == 5) {
        this.sysMsgList("", "", 2);
      }else if (item.id == 6) {
        this.sysMsgList(1, "", "");
      }
      this.select = item.id;
    },
    // 消息列表
    async sysMsgList(msgType, msgStatus, delFlag) {
      var data = {};
      // 处理时间
      var time;
      var timeEnd;
      var arr;
      var arr1;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
        arr = new Date(time).getTime(time);
        arr1 = new Date(timeEnd).getTime(timeEnd);
      }
      data.data = {
        companyId: this.$store.getters.getCompany.id, //id
        msgType: msgType, // 消息类型 0系统消息
        msgStatus: msgStatus, // 消息状态 0未读 1已读
        delFlag: delFlag, //消息 0全部消息  2回收站
        startTime: arr, // 搜索/筛选传的 开始时间
        endTime: arr1, // 搜索/筛选传的 结束时间
      };
      const res = await sysCompanyMsgList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      if (res.code == 0) {
        this.pagingObj.totalDevice = res.data.totalCount;
        this.tableData = res.data.rows;
      }
    },
    // 重置
    handelReset() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.value1 = null;
      this.RefreshSysMsgList();
    },
    // 搜索
    handelSearch() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      this.RefreshSysMsgList();
    },
    //批量恢复
    handelBatchRecovery() {
      if (!this.$checkAction()) return
      // 大于0表格已有选中 反之表格并无数据选中
      if (this.multipleSelection.length > 0) {
        this.$confirmWithScroll(`确定要恢复选中的 ${this.multipleSelection.length} 条消息吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var arr = [];
          var k = 0;
          // 循环取出msgId放入数组
          for (var i in this.multipleSelection) {
            arr[k++] = this.multipleSelection[i].msgId;
          }
          var data = {
            data: {
              msgIds: arr,
            },
          };
          restoreCompanyMsg(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.Refresh();
            }
          });
        }).catch(() => {
          // 用户取消恢复
        });
      } else {
        this.$tool.PromptBox("warning", "请选择要恢复的数据");
      }
    },
    // 批量删除
    handelDele() {
      if (!this.$checkAction()) return
      if (this.multipleSelection.length > 0) {
        const confirmText = this.select == "5" ? `确定要彻底删除选中的 ${this.multipleSelection.length} 条消息吗？` : `确定要删除选中的 ${this.multipleSelection.length} 条消息吗？`;
        this.$confirmWithScroll(confirmText, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var arr = [];
          var k = 0;
          // 循环取出msgId放入数组
          for (var i in this.multipleSelection) {
            arr[k++] = this.multipleSelection[i].msgId;
          }
          var data = {
            data: {
              msgIds: arr,
            },
          };
          // 判断操作的是回收站的数据还是其他列表的数据
          if (this.select == "5") {
            // 等于5是在回收站 删除时使用彻底删除接口
            delCompanyMsg(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.Refresh();
              }
            });
          } else {
            // 其余情况使用将数据放入回收站接口
            trashCompanyMsg(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.Refresh();
              }
            });
          }
        }).catch(() => {
          // 用户取消删除
        });
      } else {
        this.$tool.PromptBox("warning", "请选择要删除的数据");
      }
    },

    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .firm-Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }
}
// screen筛选
.screen {
  margin-bottom: 0;
}
.button {
  width: 75px !important;
  height: 35px !important;
  padding: 0 !important;
  line-height: 35px !important;
  text-align: center;
  border-radius: 5px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  font-weight: 400;
  box-sizing: border-box;
  border: 1px solid #409eff !important;
  cursor: pointer;
}
// 切换
.Toggle {
  width: 90%;
  height: 30px;
  margin-top: 30px;
  display: flex;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  text-align: center;
  font-weight: 400;
  .toggle-item {
    margin-right: 30px;
    cursor: pointer;
  }
  .select-p {
    color: #409eff ;
    box-sizing: border-box;
    border-bottom: 2px solid #409eff ;
  }
}
// 批量删除  批量恢复
.batch-btn {
  width: 100%;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  .batch-action {
    width: 100px !important;
    height: 35px !important;
    padding: 0 !important;
    line-height: 35px !important;
    background: #409eff !important;
    border-color: #409eff !important;
    border-radius: 5px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #ffffff !important;
    text-align: center;
    font-weight: 400;
    margin-left: 20px;
    cursor: pointer;
  }
  .delete-p {
    background: #fe574a !important;
    border-color: #fe574a !important;
  }
  .Tips {
    flex: 1;
    text-align: left;
    font-size: 14px;
    color: #fe574a;
    font-weight: 400;
  }
}
// 收藏的内容
.collected {
  width: 100%;
  min-height: 410px;
  margin-top: 15px;
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
